import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ScrollHelper } from 'src/shared/helpers/scroll';
const HIGHLIGHT_TIME = 2000; // 2 seconds
const LAYOUT_SETTLE_DELAY = 100; // 0.1 second
const HOST_HEADER_OFFSET = 85;
export function useScrollToHighlightedModule({ ref, isModuleInView, moduleId, onHighlight }) {
    const [isHighlighted, setIsHighlighted] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const pageId = searchParams.get('pageId');
    const isHighlightedItem = searchParams.get('moduleId') === moduleId;
    const shouldScrollToModule = !pageId || (pageId && !isModuleInView);
    useEffect(function scrollToCardIfHighlighted() {
        if (!isHighlightedItem || !ref?.current)
            return;
        onHighlight?.();
        if (!shouldScrollToModule)
            return;
        setTimeout(() => {
            ScrollHelper.scrollTo(ref, HOST_HEADER_OFFSET);
            setIsHighlighted(true);
            setTimeout(() => setIsHighlighted(false), HIGHLIGHT_TIME);
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('moduleId');
            setSearchParams(newParams);
        }, LAYOUT_SETTLE_DELAY);
    }, [ref, searchParams, isHighlightedItem, shouldScrollToModule, onHighlight, setSearchParams]);
    return isHighlighted;
}
